/**
 * A simple record abstraction over data returned
 * from the Giphy API.
 */

import Record from 'lib/record'

class GIF extends Record({ src : null }) {

  constructor({ src, images={} }) {
    super({
      src: 'original' in images ? images.original.url : null
    })
  }

}

export default GIF



/** WEBPACK FOOTER **
 ** ./web/static/app/records/gif.js
 **/